export enum RegistrationFormStatus {
  /// <summary>
  /// U tijeku prvi potpis - Sustav je generirao upisnicu i poslao na potpis prvom roditelju/skrbniku
  /// </summary>
  FirstSignatureInProgress = 1,
  /// <summary>
  /// Jedan potpis - Prvi roditelj/skrbnik je potpisao upisnicu
  /// </summary>
  OneSignature,
  /// <summary>
  /// U tijeku drugi potpis - Administrator škole je poslao upisnicu na potpis drugom roditelju/skrbniku
  /// </summary>
  SecondSignatureInProgress,
  /// <summary>
  /// Dva potpisa - Drugi roditelj/skrbnik je potpisao upisnicu
  /// </summary>
  TwoSignatures,

  // This is a virtual status to indicate we are finished.
  AllSignatures,
}
